export default "__VITE_ASSET__CsdZPDOc__"